
define('text!templates/modules/questionnaire/modal/fill-questionnaire-content.html',[],function () { return '<div class="panel-body member-questionnaire">\n    <div class="questionnaire-header">\n        <h4>{{title}}</h4>\n        <p>{{guidelines}}</p>\n    </div>\n    <div class="info-section">\n        <div class="questions-list form-section"></div>\n    </div>\n</div>\n';});

